(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/shared-components/products/products.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/shared-components/products/products.js');
"use strict";


const _svs$tickets_giftshop = svs.tickets_giftshop.products.components,
  CardList = _svs$tickets_giftshop.CardList,
  CardImageList = _svs$tickets_giftshop.CardImageList;
const Products = _ref => {
  let _ref$products = _ref.products,
    products = _ref$products === void 0 ? [] : _ref$products,
    isImageOnly = _ref.isImageOnly;
  if (!products.length) return null;
  return React.createElement("div", {
    className: "tg-products col-sm-12 col-lg-8"
  }, isImageOnly ? React.createElement(CardImageList, {
    products: products
  }) : React.createElement(CardList, {
    products: products
  }));
};
svs.tickets_giftshop.products.Products = Products;

 })(window);